export interface Statistics {
	pci: number;
	eNodeBID: number;
	model: number;
	firmware: number;
	report: number;
	pendingScheduler: number;
	cbsdAuthorized: number;
	group: number;
};

export interface DeviceStatus {
	Online: { count: number, percentage: number };
	Offline: { count: number, percentage: number };
	Total: number;
};

export interface DataSet {
	labels: Array<string>;
	data: Array<number>;
	backgroundColor: Array<string>;
	borderWidth?: number,
	hoverBorderWidth?: number
};

export enum ConnectedClass {
	CARRIER = "Carrier",
	MODEL = "Model",
	NETWORK = "Network_Type",
	RADIO = "Radio_Type"
};

export interface DataSets {
	[ConnectedClass.CARRIER]: DataSet | null;
	[ConnectedClass.MODEL]: DataSet | null;
	[ConnectedClass.NETWORK]: DataSet | null;
	[ConnectedClass.RADIO]: DataSet | null;
};

